import { createContext, useEffect, useReducer } from "react";

import axios from "../utils/axios";
import PaidInvoiceReducer from "../reducers/PaidInvoiceReducer";
import { isValidToken, setSession } from "../utils/jwt";
import { PaidInvoiceConstants } from "../constants/paidinvoice.constants";
import { saveFile } from "../utils/common";
const initialState = {
  paidInvoices: [],
  receipts: [],
  paging: {
    totalNumberOfRecords: 0,
    totalNumberOfPages: 0,
    pageNumber: 0,
    pageSize: 0,
  },
  hasError: false,
  errorMessage: "",
  smsLogSearchResults: [],
  smsLog: {},
  isUpload: false,
  uploadError: false,
  uploadSuccess: false,
  isSubmitting: false,
  smsLogAutoSearchResults: {
    data: [],
    paging: {
      hasNextPage: false,
      hasPreviousPage: false,
      pageNumber: 0,
      pageSize: 0,
      totalNumberOfPages: 0,
      totalNumberOfRecords: 0,
    },
  },
  isLoadingAutoSearch: false,
};
const initPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

const PaidInvoiceContext = createContext({
  ...initialState,
  getAllPaidInvoice: () => {},
  addPaidInvoice: () => {},
  searchPaidInvoice: () => {},
  autoSearchPaidInvoice: () => {},
  getPaidInvoice: () => {},
  updatePaidInvoice: () => {},
  downloadFile: () => {},
  sampleFile: () => {},
  uploadFile: () => {},
  getAllGstInvoice: () => {},
  downloadGstInvoiceFile: () => {},
  getAllReceipts: () => {},
});

function PaidInvoiceProvider({ children }) {
  const [state, dispatch] = useReducer(PaidInvoiceReducer, initialState);

  const getAllPaidInvoice = async (payload) => {
    try {
      dispatch({
        type: PaidInvoiceConstants.FETCH_PAIDINVOICE_REQUEST,
      });
      const response = await axios.post("/radius/raduser/paid-invoices", payload);
      dispatch({
        type: PaidInvoiceConstants.FETCH_PAIDINVOICE_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: PaidInvoiceConstants.FETCH_PAIDINVOICE_FAILURE,
      });
    }
  };
  const getAllGstInvoice = async (payload) => {
    try {
      dispatch({
        type: PaidInvoiceConstants.FETCH_PAIDINVOICE_REQUEST,
      });
      const response = await axios.post("/radius/raduser/gst-invoices", payload);
      dispatch({
        type: PaidInvoiceConstants.FETCH_PAIDINVOICE_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: PaidInvoiceConstants.FETCH_PAIDINVOICE_FAILURE,
      });
    }
  };
  const searchPaidInvoice = async (payload) => {
    try {
      const response = await axios.post("/radius/raduser/paid-invoices/search", payload);
      dispatch({
        type: PaidInvoiceConstants.PAIDINVOICE_SEARCH_REQUEST,
      });
      console.log(response.data, "response.data");
      dispatch({
        type: PaidInvoiceConstants.PAIDINVOICE_SEARCH_SUCCESS,
        payload: response.data,
      });
    } catch (exception) {
      dispatch({
        type: PaidInvoiceConstants.PAIDINVOICE_SEARCH_FAILURE,
      });
    }
  };
  const autoSearchPaidInvoice = async (payload) => {
    try {
      const response = await axios.post("/radius/raduser/paid-invoices/auto-search", payload);
      dispatch({
        type: PaidInvoiceConstants.PAIDINVOICE_AUTO_SEARCH_REQUEST,
      });
      console.log(response.data, "response.data");
      dispatch({
        type: PaidInvoiceConstants.PAIDINVOICE_AUTO_SEARCH_SUCCESS,
        payload: response.data,
      });
    } catch (exception) {
      dispatch({
        type: PaidInvoiceConstants.PAIDINVOICE_AUTO_SEARCH_FAILURE,
      });
    }
  };

  const getPaidInvoice = async (id) => {
    const response = await axios.get("/radius/raduser/paid-invoices/" + id);
    dispatch({
      type: PaidInvoiceConstants.GET_PAIDINVOICE_REQUEST,
    });
    dispatch({
      type: PaidInvoiceConstants.GET_PAIDINVOICE_SUCCESS,
      payload: response.data,
    });
    return response.data;
  };

  const downloadFile = async (fileType, payload) => {
    try {
      dispatch({
        type: PaidInvoiceConstants.DOWNLOAD_PAIDINVOICE_REQUEST,
        payload: { fileType },
      });
      const response = await axios.post(
        "/radius/raduser/paid-invoices/export/" + fileType,
        payload,
        { responseType: "blob" },
      );
      await saveFile(response.data, "paid-invoice." + fileType);
      dispatch({
        type: PaidInvoiceConstants.DOWNLOAD_PAIDINVOICE_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      console.error("Download failed:", error);
      dispatch({ type: PaidInvoiceConstants.DOWNLOAD_PAIDINVOICE_FAILURE });
      throw error;
    }
  };

  const downloadGstInvoiceFile = async (fileType, payload) => {
    try {
      dispatch({
        type: PaidInvoiceConstants.DOWNLOAD_GST_INVOICE_REQUEST,
        payload: { fileType },
      });
      const response = await axios.post(
        "/radius/raduser/gst-invoices/export/" + fileType,
        payload,
        {
          responseType: "blob",
        },
      );
      await saveFile(response.data, "gst-invoices." + fileType);
      dispatch({
        type: PaidInvoiceConstants.DOWNLOAD_GST_INVOICE_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      console.error("Download failed:", error);
      dispatch({ type: PaidInvoiceConstants.DOWNLOAD_GST_INVOICE_FAILURE });
      throw error;
    }
  };

  const getAllReceipts = async (payload) => {
    try {
      dispatch({
        type: PaidInvoiceConstants.FETCH_RECEIPT_REQUEST,
      });
      const response = await axios.post("/radius/raduser/receipts", payload);
      dispatch({
        type: PaidInvoiceConstants.FETCH_RECEIPT_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: PaidInvoiceConstants.FETCH_RECEIPT_FAILURE,
      });
    }
  };

  const downloadReceipts = async (fileType, payload) => {
    try {
      dispatch({
        type: PaidInvoiceConstants.DOWNLOAD_RECEIPT_REQUEST,
        payload: { fileType },
      });
      const response = await axios.post("/radius/raduser/receipts/export/" + fileType, payload, {
        responseType: "blob",
      });
      await saveFile(response.data, "receipts." + fileType);
      dispatch({
        type: PaidInvoiceConstants.DOWNLOAD_RECEIPT_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      console.error("Download failed:", error);
      dispatch({ type: PaidInvoiceConstants.DOWNLOAD_RECEIPT_FAILURE });
      throw error;
    }
  };

  return (
    <PaidInvoiceContext.Provider
      value={{
        ...state,
        getAllPaidInvoice,
        searchPaidInvoice,
        autoSearchPaidInvoice,
        getPaidInvoice,
        downloadFile,
        getAllGstInvoice,
        downloadGstInvoiceFile,
        getAllReceipts,
        downloadReceipts,
      }}
    >
      {children}
    </PaidInvoiceContext.Provider>
  );
}

export { PaidInvoiceContext, PaidInvoiceProvider };
